import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-black py-16 px-4" data-id="element-121">
      <div className="max-w-2xl mx-auto text-center" data-id="element-122">
        {/* Shield icon */}
        <div className="text-8xl mb-6" data-id="element-123">🛡️</div>

        <h2 className="text-3xl sm:text-4xl font-black text-[#FF6B00] mb-4" data-id="element-124">
          GARANTÍA PROFEPACK — 7 DÍAS
        </h2>

        <div className="bg-[#0d0800] border-2 border-[#FF6B00] rounded-2xl p-8 mb-6" data-id="element-125">
          <p className="text-white text-lg mb-4 leading-relaxed" data-id="element-126">
            Abrís los 12 tomos. Revisás los 6 bonos. Los usás en el aula si
            querés.
          </p>
          <p className="text-white text-lg mb-6 leading-relaxed" data-id="element-127">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="text-[#FF6B00] text-3xl font-black mb-4" data-id="element-128">
            Te devolvemos el 100%.
          </p>
          <p className="text-white text-xl font-bold" data-id="element-129">
            Sin preguntas. Sin formularios. Sin drama.
          </p>
        </div>

        <p className="text-gray-400 text-sm leading-relaxed" data-id="element-130">
          La confianza que tenemos en PROFEPACK nos permite ofrecerte eso.
          <br data-id="element-131" />
          Más de 3.000 docentes de Inglés ya lo saben.
        </p>
      </div>
    </section>;
}